export const frenchFormat = (price: number) => {
  if (!price) {
    return '0'
  }
  if (Number.isInteger(price)) {
    return `${price.toLocaleString('fr-FR')}`
  }
  return `${price.toLocaleString('fr-FR', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })}`
}

export const euroRoundPrice = (price: number) => {
  const newPrice = Math.floor(price * 10) / 10
  return newPrice
}

const defaultPromo = process.env.NODE_ENV === 'test' ? 40 : 30

// Default anti gaspi price is 70%
export const getAntiGaspiPrice = (price: number, promo = defaultPromo) =>
  euroRoundPrice(price * ((100 - promo) / 100))

export const tauxPrice = (price: number, taux: number) =>
  euroRoundPrice(price * (1 - taux / 100 / 100))

export const centRound = (price: number) => Math.round(price * 100) / 100

export const euroToCents = (price: number) => Math.round(price * 100)

export const isQuiteSamePrice = (price1: number, price2: number) => Math.abs(price1 - price2) < 0.02
